import Vue from 'vue';
import projectTransformer from './../../transformers/project';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(projectTransformer.fetch(errors));
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('projects', data)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/project/store.js